export const toSymbol = val => {
	switch (val) {
		case 'uah':
			return '₴'
		case 'usd':
			return '$'
		case 'eur':
			return '€'
		case 'rub':
			return '₽'
		case 'nis':
			return '₪'
		case 'azn':
			return '₼'
		case 'pln':
			return 'zł'
	}
}
